import React from "react"
import Typography from "@mui/material/Typography";
import {metaDataProperty} from "../preview/previewMetaData";
import {usePreviewContext} from "../../context/PreviewContext";

interface Props {
    title?: string | null,
    propertyName?: string,
    isH1Activated?: boolean,
    metadataId?: string,
    align?: 'left' | 'center' | 'right'
}

function CCOH1(props: Props) {
    const align = props.align || 'center';
    const isPreview = usePreviewContext().isPreview;
    return props.isH1Activated && props.title && props.title.length > 0 ?
        <Typography
            variant={'h1'}
            {...metaDataProperty(isPreview, props.propertyName, props.metadataId)}
            sx={{
                textAlign: align,
                marginTop: 2,
                marginBottom: 8
            }}>
            {props.title}
        </Typography>
        : <React.Fragment/>;

}

export default CCOH1